import axios from 'axiosWrapper';

export async function sendTextToSpeech(form) {
    return await axios.post('/api/speechkit/tts', form, {
        responseType: 'arraybuffer',
    });
}
